document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (menuButton && mobileMenu) {
    menuButton.setAttribute('aria-expanded', 'false');

    menuButton.addEventListener('click', () => {
      const isOpen = mobileMenu.classList.toggle('open');
      menuButton.setAttribute('aria-expanded', String(isOpen));
      menuButton.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    });
  }

  document.querySelectorAll('.submenu-toggle').forEach((toggle) => {
    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const item = toggle.closest('.nav-item');
      const submenu = item ? item.querySelector(':scope > .submenu') : null;
      if (!item || !submenu) return;

      const isOpen = item.classList.toggle('submenu-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
      toggle.setAttribute(
        'aria-label',
        `${isOpen ? 'Close' : 'Open'} ${item.querySelector(':scope > .nav-row .nav-link')?.textContent.trim() || ''} submenu`
      );
      submenu.hidden = !isOpen;
    });
  });
});
